import { AnnualClock } from "api-client/models/AnnualClock";

export enum ACTIONS {
    GET_ANNUAL_CLOCK_REQUEST = "GET_ANNUAL_CLOCK_REQUEST",
    GET_ANNUAL_CLOCK_SUCCESS = "GET_ANNUAL_CLOCK_SUCCESS",
    GET_ANNUAL_CLOCK_FAILURE = "GET_ANNUAL_CLOCK_FAILURE",
}

interface GetAnnualClockRequest {
    type: ACTIONS.GET_ANNUAL_CLOCK_REQUEST;
}

interface GetAnnualClockSuccess {
    type: ACTIONS.GET_ANNUAL_CLOCK_SUCCESS;
    payload: AnnualClock;
}

interface GetAnnualClockFailure {
    type: ACTIONS.GET_ANNUAL_CLOCK_FAILURE;
}

export type ActionType = GetAnnualClockRequest | GetAnnualClockSuccess | GetAnnualClockFailure;
